import { useEffect } from 'react'
import { LANGUAGE_META } from '../geo/config'

declare global {
  interface Window {
    LanguageConfig?: Record<string, any>
  }
}

export const useLanguageSync = ({
  allowedLanguages,
  language,
  languageMeta,
  scriptLoaded,
}: any) => {
  useEffect(() => {
    if (!scriptLoaded) return

    const switcher = document.getElementById('languageSwitcher')
    const selected = switcher?.querySelector('.selected')
    if (!selected) return

    const syncAllowedLanguages = () => {
      const dropdown = switcher?.querySelector('.dropdown-list')
      if (!(dropdown instanceof HTMLUListElement)) return

      dropdown.innerHTML = ''

      allowedLanguages.forEach((allowedLanguage: string) => {
        const meta =
          window.LanguageConfig?.[allowedLanguage] ??
          LANGUAGE_META[allowedLanguage as keyof typeof LANGUAGE_META]

        if (!meta) return

        const item = document.createElement('li')
        if (allowedLanguage === language) {
          item.classList.add('active')
        }

        const image = document.createElement('img')
        image.src = meta.flag
        image.alt = allowedLanguage

        const label = document.createElement('span')
        label.textContent = meta.label.toUpperCase()

        item.append(image, label)
        dropdown.appendChild(item)
      })
    }

    const selectedImage = selected.querySelector('img')
    const selectedLabel = selected.querySelector('span')

    if (selectedImage instanceof HTMLImageElement) {
      selectedImage.src = languageMeta.flag
      selectedImage.alt = languageMeta.label.toLowerCase()
    }

    if (selectedLabel) {
      selectedLabel.textContent = languageMeta.label
    }

    syncAllowedLanguages()

    const timer = window.setInterval(() => {
      if (!window.LanguageConfig) return
      syncAllowedLanguages()
      window.clearInterval(timer)
    }, 100)

    return () => window.clearInterval(timer)
  }, [allowedLanguages, language, languageMeta, scriptLoaded])
}